import { combineReducers } from 'redux';
import { persistReducer } from 'redux-persist';
import storage from 'redux-persist/lib/storage';

//login
import phoneInputComponent from 'js/core/reducers/components/phoneInputReducer';
import codeInputComponent from 'js/core/reducers/components/codeInputReducer';
import signInComponent from 'js/core/reducers/components/signInReducer';

//estabelecimentos
import establishmentInformationComponent from 'js/core/reducers/components/establishmentInformationReducer';

//Queries
import batchActionsComponent from 'js/core/reducers/components/batchActionsReducer';

//store
import storePromotionComponent from 'js/core/reducers/components/storePromotionReducer';

//campanhaTriibo
import campaingTriiboComponent from 'js/core/reducers/components/campaingTriiboReducer';

//Geração de Voucher
import generationInformationComponent from 'js/core/reducers/components/generationInformationReducer';

//Envio de Voucher
import voucherSendComponent from 'js/core/reducers/components/voucherSendReducer';

// QR Code
import generateQRCodeComponent from 'js/core/reducers/components/generateQRCodeReducer';
import listQRCodeComponent from 'js/core/reducers/components/listQRCodeReducer';
import deleteQRCodeComponent from 'js/core/reducers/components/deleteQRCodeReducer';

// Duplicar promoção
import duplicatePromotionComponent from 'js/core/reducers/components/duplicatePromotionReducer';

//Marketing Template
import marketingTemplateComponent from 'js/core/reducers/components/marketingTemplateReducer';

//models
import generationInformationModel from 'js/core/reducers/models/generationInformationModel';
import phoneInputModel from 'js/core/reducers/models/phoneInputModel';
import codeInputModel from 'js/core/reducers/models/codeInputModel';
import signInModel from 'js/core/reducers/models/signInModel';
import sendNotificationsModel from 'js/core/reducers/models/sendNotifications';
import establishmentInformationModel from 'js/core/reducers/models/establishmentInformationModel';
import batchActionsModel from 'js/core/reducers/models/batchActionsModel';
import campaingTriiboModel from 'js/core/reducers/models/campaingTriiboModel';
import marketingTemplateModel from 'js/core/reducers/models/marketingTemplateModel';
import listCardsModel from 'js/core/reducers/models/listCardsModel';
import generateQRCodeModel from 'js/core/reducers/models/generateQRCodeModel';
import authModel from 'js/core/reducers/models/authModel';
import trialModel from 'js/core/reducers/models/trialModel';
import currentEstModel from 'js/core/reducers/models/currentEstModel';

export default combineReducers({
  phoneInputModel: createReducer('phoneInput', phoneInputModel),
  codeInputModel: createReducer('codeInput', codeInputModel),
  signInModel: createReducer('signIn', signInModel),
  establishmentInformationModel: createReducer(
    'establishmentInformation',
    establishmentInformationModel
  ),
  sendNotificationsModel: createReducer('establishmentInformation', sendNotificationsModel),
  listCardsModel: createReducer('listCards', listCardsModel),
  authModel: createReducer('auth', authModel),
  trialModel: createReducer('trial', trialModel),
  currentEstModel: createReducer('currentEst', currentEstModel),

  batchActionsModel: createReducer('batchActions', batchActionsModel),

  generationInformationModel: createReducer('generationInformation', generationInformationModel),
  campaingTriiboModel: createReducer('campaingTriibo', campaingTriiboModel),
  marketingTemplateModel: createReducer('marketingTemplate', marketingTemplateModel),
  generateQRCodeModel: createReducer('generationQRCode', generateQRCodeModel),

  phoneInputComponent: phoneInputComponent,
  codeInputComponent: codeInputComponent,
  signInComponent: signInComponent,
  establishmentInformationComponent: establishmentInformationComponent,
  storePromotionComponent: storePromotionComponent,
  voucherSendComponent: voucherSendComponent,
  generationInformationComponent: generationInformationComponent,
  batchActionsComponent: batchActionsComponent,
  listQRCodeComponent: listQRCodeComponent,
  deleteQRCodeComponent: deleteQRCodeComponent,
  duplicatePromotionComponent: duplicatePromotionComponent,
  marketingTemplateComponent: marketingTemplateComponent,
  campaingTriiboComponent: campaingTriiboComponent,
  generateQRCodeComponent: generateQRCodeComponent,
});

function createReducer(key, reducer) {
  return persistReducer(createConfig(key), reducer);
}

function createConfig(key) {
  return {
    key: key,
    storage,
  };
}

